// src/pages/Posts.js

import React from "react";
import { Link } from "react-router-dom";
import postsData from "../data/posts.json";
import styles from "./Posts.module.css";

function Posts({ showOnHome = false }) {
  // If showOnHome, only show 10
  const displayedPosts = showOnHome ? postsData.slice(0, 10) : postsData;

  return (
    <div className={styles.container}>
      {!showOnHome && <h1>Blog Posts</h1>}
      <div className={styles.postsGrid}>
        {displayedPosts.map((post) => (
          <div key={post.id} className={styles.postCard}>
            <img src={post.image} alt={post.title} className={styles.postImage} />
            <h2>{post.title}</h2>
            <h3>{post.subtitle}</h3>
            <Link to={`/posts/${post.id}`} className={styles.readMore}>
              Read More
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Posts;